import { render } from "./invoiceOverview.vue?vue&type=template&id=501894c0"
import script from "./invoiceOverview.vue?vue&type=script&lang=js"
export * from "./invoiceOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__